import React from "react";
import { Card, Select, Typography, Row, Col, Button } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";

const OfferSpecification = ({
  clientReturnAddresses,
  returnAddress,
  setReturnAddress,
  clientPayeeNames,
  payeeName,
  setPayeeName,
  callCenters,
  callCenter,
  handleCallCenterChange,
  phoneNumbers,
  phoneNumber,
  setPhoneNumber,
  paymentDetails,
  paymentDetail,
  setPaymentDetail,
  warranty,
  setWarranty,
  giftVisible,
  setGiftVisible,
  setModalProps,
  handleAddPaymentDetail,
  setCallCenter
}) => {
  return (
    <Card 
      style={{ width: '100%' }}
      title={<Typography.Title level={5}>Offer Specification</Typography.Title>}
    >
      <Row gutter={[16, 16]}>
        <Col lg={12} sm={12} xs={24}>
          <div style={{ marginBottom: 8 }}>
            <Typography.Text strong>Return Envelope Address</Typography.Text>
          </div>
          <Select
            style={{ width: '100%' }}
            options={clientReturnAddresses.map(option => ({
              label: option.label,
              value: option.value
            }))}
            value={returnAddress ? returnAddress.value : undefined}
            onChange={(value) => {
              const selectedOption = clientReturnAddresses.find(opt => opt.value === value);
              setReturnAddress(selectedOption);
            }}
            placeholder="Select Envelope Address"
          />
        </Col>

        <Col lg={12} sm={12} xs={24}>
          <div style={{ marginBottom: 8 }}>
            <Typography.Text strong>Payee Name</Typography.Text>
          </div>
          <Select
            style={{ width: '100%' }}
            options={clientPayeeNames.map(option => ({
              label: option.label,
              value: option.value
            }))}
            value={payeeName ? payeeName.value : undefined}
            onChange={(value) => {
              const selectedOption = clientPayeeNames.find(opt => opt.value === value);
              setPayeeName(selectedOption);
            }}
            placeholder="Select Payee Name"
          />
        </Col>

        <Col lg={12} sm={12} xs={24}>
          <div style={{ marginBottom: 8 }}>
            <Typography.Text strong>Call Center</Typography.Text>
          </div>
          <Select
            style={{ width: '100%' }}
            options={callCenters.map(option => ({
              label: option.label,
              value: option.value
            }))}
            value={callCenter ? callCenter.value : undefined}
            onChange={(value) => {
              const selectedOption = callCenters.find(opt => opt.value === value);
              setCallCenter(selectedOption);
              handleCallCenterChange(selectedOption);
            }}
            placeholder="Select Call Center"
          />
        </Col>
        
        <Col lg={12} sm={12} xs={24}>
          <div style={{ marginBottom: 8 }}>
            <Typography.Text strong>Phone Number</Typography.Text>
          </div>
          <Select
            style={{ width: '100%' }}
            options={phoneNumbers.map(option => ({
              label: option.label,
              value: option.value
            }))}
            value={phoneNumber ? phoneNumber.value : undefined}
            onChange={(value) => {
              const selectedOption = phoneNumbers.find(opt => opt.value === value);
              setPhoneNumber(selectedOption);
            }}
            placeholder="Select Phone Number"
          />
        </Col>
        
        <Col lg={12} sm={12} xs={24}>
          <div style={{ marginBottom: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography.Text strong>Payment Details</Typography.Text>
            <Button
              type="primary"
              size="small"
              icon={<PlusCircleOutlined />}
              onClick={() => {
                setModalProps({
                  title: "Payment Details",
                  onSubmit: handleAddPaymentDetail,
                });
              }}
              data-bs-toggle="modal"
              data-bs-target="#add-units-category"
            >
              Add New
            </Button>
          </div>
          <Select
            style={{ width: '100%' }}
            options={paymentDetails.map(option => ({
              label: option.label,
              value: option.value
            }))}
            value={paymentDetail ? paymentDetail.value : undefined}
            onChange={(value) => {
              const selectedOption = paymentDetails.find(opt => opt.value === value);
              setPaymentDetail(selectedOption);
            }}
            placeholder="Select Payment Details"
          />
        </Col>
        
        <Col lg={12} sm={12} xs={24}>
          <div style={{ marginBottom: 8 }}>
            <Typography.Text strong>Warranty (Days)</Typography.Text>
          </div>
          <Select
            style={{ width: '100%' }}
            options={Array.from({ length: 13 }, (_, i) => ({
              value: i * 30,
              label: `${i * 30}`,
            }))}
            value={warranty}
            onChange={(value) => setWarranty(value)}
            placeholder="Select Warranty Period"
            showSearch
          />
        </Col>

        <Col lg={12} sm={12} xs={24}>
          <div style={{ marginBottom: 8 }}>
            <Typography.Text strong>Gift Visible in Offer</Typography.Text>
          </div>
          <Select
            style={{ width: '100%' }}
            options={[
              { value: "Yes", label: "Yes" },
              { value: "No", label: "No" },
            ]}
            value={giftVisible}
            onChange={(value) => setGiftVisible(value)}
            placeholder="Yes or No"
          />
        </Col>
      </Row>
    </Card>
  );
};

export default OfferSpecification;
